import { transitionDurations } from "../../theme";

export const snackbarStackItemVariants = {
  initial: {
    opacity: 0,
    y: 0,
    scale: 0.9,
    transition: {
      duration: transitionDurations.s,
      ease: "easeOut" as const,
    },
  },
  animate: ({ index }: { index: number; count: number }) => ({
    y: -(index * 20),
    scale: 1 - 0.05 * index,
    opacity: 1,
    transition: {
      duration: transitionDurations.s,
      ease: "easeOut" as const,
      type: "spring" as const,
      stiffness: 500,
      damping: 30,
    },
  }),
  exit: {
    opacity: 0,
    scale: 1,
    x: 42,
    transition: {
      duration: transitionDurations.xs,
      ease: "easeIn" as const,
    },
  },
};

export const snackbarContainerVariants = {
  initial: {
    opacity: 1,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: transitionDurations.xs,
      staggerChildren: 0.05,
      when: "beforeChildren" as const,
    },
  },
};
